import { Box } from "@chakra-ui/react";

import { baseColors } from "../../tokens";

/** Figma 원본 일러스트 좌표계. 컨테이너 폭이 달라져도 그림이 늘어나지 않게 고정한다 */
const ILLUST_WIDTH = 280;
const ILLUST_HEIGHT = 144;
/** 좌표가 중앙 기준(calc(50% ± n))으로 잡혀 있어 반폭을 상수로 둔다 */
const ILLUST_CENTER = ILLUST_WIDTH / 2;

/**
 * "지금 상조 비용 vs N년 뒤 비용" 막대 그래프.
 *
 * Figma 원본은 회전 벡터가 없는 사각형·원·점선 조합이라 에셋 없이 CSS로 그린다.
 * 점선과 원은 둘 다 `#36383A`(gray_800) 단색이라 내보낼 이유가 없었다.
 * 견적 재제출 결과(PrimeSection)에서 쓴다.
 */
export const PriceRiseIllustration = () => (
  <Box
    position="relative"
    width={`${ILLUST_WIDTH}px`}
    height={`${ILLUST_HEIGHT}px`}
    maxWidth="100%"
    borderRadius="12px"
    overflow="hidden"
    aria-hidden
  >
    {/* 지금 비용 막대. 두 막대의 밑변(118px)을 맞춘다 */}
    <Box
      position="absolute"
      left="77.5px"
      top="62px"
      width="52px"
      height="56px"
      bg={baseColors.white}
    />

    {/* N년 뒤 막대. 흰 막대 위에 오렌지 증가분을 덮어 "오른 만큼"을 보여준다 */}
    <Box
      position="absolute"
      left="138.5px"
      top="12px"
      width="52px"
      height="106px"
      bg={baseColors.white}
      borderTopRadius="4px"
    />
    <Box
      position="absolute"
      left="138.5px"
      top="12px"
      width="52px"
      height="50px"
      bg={baseColors.orange_300}
      borderTopRadius="4px"
    />

    {/* 지금 가격 기준선 */}
    <Box
      position="absolute"
      left="68.5px"
      top="60px"
      width="131px"
      height="2px"
      backgroundImage={`repeating-linear-gradient(to right, ${baseColors.label_alternative_2} 0 4.26px, transparent 4.26px 8.52px)`}
    />

    <Box
      position="absolute"
      left={`${ILLUST_CENTER - 36.5}px`}
      top="122px"
      width="58px"
      textAlign="center"
      fontSize="10px"
      fontWeight={500}
      lineHeight="16px"
      color={baseColors.label_alternative_1}
    >
      지금 상조 비용
    </Box>
    <Box
      position="absolute"
      left={`${ILLUST_CENTER + 24.5}px`}
      top="122px"
      width="58px"
      textAlign="center"
      fontSize="10px"
      fontWeight={600}
      lineHeight="16px"
      color={baseColors.label_alternative_1}
    >
      N년 뒤 비용
    </Box>

    {/* 가격 고정 배지 */}
    <Box
      position="absolute"
      left="203.5px"
      top="37px"
      width="48px"
      height="48px"
      borderRadius="50%"
      bg={baseColors.label_alternative_2}
      display="flex"
      alignItems="center"
      justifyContent="center"
      fontSize="10px"
      fontWeight={700}
      color={baseColors.white}
    >
      가격 고정
    </Box>
  </Box>
);
